const BASE_CLIENTS_API_URL = '/clients';
const BASE_DQP_USER_API_URL = '/dqpuser';

/**
 * Application Constants
 */
export const CONSTANT = {
	// Water User API
	API_BASE_URL: getConfigValue(process.env.NEXT_PUBLIC_API_BASE_URL),
	LINKING_CODE_API_URL: '/externalidentity',
	LINKING_REFS_API_URL: '/linkcontact',
	LINKINGS_API_URL: '/reportedissue',
	LEGAL_ENTITIES_API_URL: BASE_CLIENTS_API_URL,
	LEGAL_ENTITY_API_URL: BASE_CLIENTS_API_URL + '/%s',
	CLIENTS_APP_API_URL: BASE_CLIENTS_API_URL,
	CLIENT_CONTACT_APP_API_URL: BASE_CLIENTS_API_URL + '/%s/contact',
	AUTHORISATIONS_API_URL: BASE_CLIENTS_API_URL + '/%s/authorisations',
	AUTHORISATIONS_DETAILS_API_URL: BASE_CLIENTS_API_URL + '/%s/authorisations/%s',
	DEVICES_API_URL: BASE_CLIENTS_API_URL + '/%s/devices',
	DEVICE_API_URL: BASE_CLIENTS_API_URL + '/%s/devices/%s',
	DEVICE_FAULTY_API_URL: BASE_CLIENTS_API_URL + '/%s/devices/%s/faulty',
	READINGS_API_URL: BASE_CLIENTS_API_URL + '/%s/meters/%s/reading',
	READING_PHOTO_API_URL: BASE_CLIENTS_API_URL + '/%s/meters/%s/reading/%s',
	DEVICE_READINGS_API_URL: BASE_CLIENTS_API_URL + '/%s/devices/%s/readings',
	DEVICE_READING_PHOTO_API_URL: BASE_CLIENTS_API_URL + '/%s/devices/%s/readings/%s',
	READING_REQUESTS_API_URL: '/reading-requests',
	WORKS_API_URL: BASE_CLIENTS_API_URL + '/%s/works',
	WATER_ACCOUNTS_API_URL: BASE_CLIENTS_API_URL + '/%s/wateraccounts',
	WATER_ACCOUNTS_UPDATE_API_URL: BASE_CLIENTS_API_URL + '/%s/wateraccounts/%s',
	USER_ACCOUNT_API_URL: '/useraccount',
	NOTIFICATIONS_API_URL: '/notifications',
	NOTIFICATION_API_URL: '/notifications/%s',
	GLOSSARY_API_URL: '/glossary',
	USERS_API_URL: '/wateruser',
	TERMS_AND_CONDITIONS_API_URL: '/termsandconditions',
	ACCEPT_TERMS_AND_CONDITIONS_API_URL: '/termsandconditions/%s',
	READ_API_URL: '/read',
	REPORT_API_URL: '/reportedissue',
	ADDRESS_SEARCH_API_URL: '/physicaladdress/search',
	ADDRESS_VALIDATE_API_URL: '/physicaladdress/validate',
	ADDRESS_PARSE_API_URL: '/physicaladdress/parse',
	EMAIL_VERIFICATION_VERIFY_API_URL: '/verifyemail',
	EMAIL_VERIFICATION_CHECK_API_URL: '/verifyemailcheck',

	// DQP User API
	DQP_API_BASE_URL: getConfigValue(process.env.NEXT_PUBLIC_DQP_API_BASE_URL),
	DQP_USER_API_URL: BASE_DQP_USER_API_URL,
	DQP_LICENCE_API_URL: BASE_DQP_USER_API_URL + '/licence',
	DQP_CERTIFICATES_API_URL: '/certificates',
	DQP_CERTIFICATE_API_URL: '/certificates/%s',
	DQP_CERTIFICATE_FILE_API_URL: '/certificates/%s/file',
	DQP_MAKES_MODELS_API_URL: '/devices/makemodels',
	DQP_METER_CASE_CODE_API_URL: '/mcc/%s',
	ME_API_URL: '/me',
	/**
	 * `480` Maximum width of the screen to consider the UI as a mobile view
	 **/
	SCREEN_MOBILE: 480,
	/**
	 * `768` Maximum width of the screen to consider the UI as a tablet view
	 **/
	SCREEN_TABLET: 768,
	/**
	 * `992` Maximum width of the screen to consider the UI as a small desktop view
	 **/
	SCREEN_SM_DESKTOP: 992,
	/**
	 * `1280` Maximum width of the screen to consider the UI as a medium desktop view
	 **/
	SCREEN_MD_DESKTOP: 1280,
	/** QLD-media Breakpoints */
	SCREEN_SM_QLDDS: 400,
	SCREEN_MD_QLDDS: 700,
	SCREEN_LG_QLDDS: 992,
	SCREEN_XL_QLDDS: 1312,
	SCREEN_2XL_QLDDS: 1599,
	/** `landscape` Landscape mode, horizontal mode  */
	LANDSCAPE: 'landscape',
	/** `portrait` Portrait mode, Vertical mode */
	PORTRAIT: 'portrait',
	/** Welcome back message */
	WELCOME_BACK: 'Welcome back',
	FORGOTTEN_URL: process.env.NEXT_PUBLIC_WIQ_URL_FORGOTPASSWORD,
	CONTACT_URL: process.env.NEXT_PUBLIC_WIQ_CONTACT_URL,
	DIGITAL_ID_FAQ: process.env.NEXT_PUBLIC_WIQ_DIGITAL_ID_FAQ_URL,
	HELP_URL: process.env.NEXT_PUBLIC_WIQ_HELP_URL,
	TERMS_AND_CONDITIONS_URL: process.env.NEXT_PUBLIC_WIQ_TERMS_AND_CONDITIONS_URL,
	WATER_HUB_EMAIL: process.env.NEXT_PUBLIC_WIQ_WATER_HUB_EMAIL,
	/** Security token service that provices the authentication token*/
	SECURITY_TOKEN_SERVICE_ISSUER: getConfigValue(process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_ISSUER),
	/** The application ID that the Azure portal assigned to the application */
	APPLICATION_ID: getConfigValue(process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_CLIENTID),
	/** User security basic level */
	SECURITY_LEVEL_BASIC: getConfigValue(
		process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_SECURITY_ASSURANCE_LEVEL_BASIC,
	),
	/** User security standard level */
	SECURITY_LEVEL_STANDARD: getConfigValue(
		process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_SECURITY_ASSURANCE_LEVEL_STANDARD,
	),
	/** User security strong level */
	SECURITY_LEVEL_STRONG: getConfigValue(
		process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_SECURITY_ASSURANCE_LEVEL_STRONG,
	),
	INVALID_UUID: '00000000-0000-0000-0000-000000000000',
	WATER_ALLOCATION: 'Water Allocation',
	INTERIM_ALLOCATION: 'Interim Water Allocation',
	LIC_TAKE_WATER: 'Licence to Take Water',
	INVALID_DATE: '0001-01-01T00:00:00',
	PERMANENT_TRADES_LEARN_MORE_URL:
		'https://www.business.qld.gov.au/industries/mining-energy-water/water/water-markets/allocation',
	PERMANENT_TRADES_INFORMATION_URL:
		'https://www.business.qld.gov.au/industries/mining-energy-water/water/water-markets/market-information',
	TEMPORARY_TRADES_LEARN_MORE_URL:
		'https://www.business.qld.gov.au/industries/mining-energy-water/water/water-markets/seasonal',
	TEMPORARY_TRADES_INFORMATION_URL:
		'https://www.business.qld.gov.au/industries/mining-energy-water/water/water-markets/seasonal/daily-information',
	BQ_ANNOUNCEMENTS_URL: getConfigValue(process.env.NEXT_PUBLIC_WIQ_BQ_ANNOUNCEMENTS_URL),

	/** QGOV URLS */
	QLD_GOV_URL: 'https://www.qld.gov.au',
	QLD_GOV_COPYRIGHT_URL: 'https://www.qld.gov.au/legal/copyright',
	QLD_GOV_PRIVACY_URL: 'https://www.qld.gov.au/legal/privacy',
	QLD_GOV_RIGHT_TO_INFORMATION_URL:
		'https://www.qld.gov.au/about/rights-accountability/right-to-information',
	QLD_GOV_ACCESSIBILITY_URL: 'https://www.qld.gov.au/help/accessibility',
	QLD_GOV_LANGUAGES_URL: 'https://www.qld.gov.au/help/languages',

	/** WATERIQ CONTACT DETAILS */
	WATERIQ_PHONE_NUMBER: '(07) 3330 4361',
	WATERIQ_EMAIL_ADDRESS: process.env.NEXT_PUBLIC_WIQ_WATER_HUB_EMAIL,
	WATERIQ_LOCATION: '1 William Street, Brisbane 4000',

	/**
	 * Exclude URLs from ITPWAF (IT Protection Web Application Firewall)
	 * Used when sending photo URLs in API requests, such as in the update certificate endpoint and retrieve certificate file endpoint
	 */
	ITPWAF_EXCLUDE: getConfigValue(process.env.NEXT_PUBLIC_ITPWAF_EXCLUDE),

	/** Max number of consecutive retries when an API service query fails */
	RETRY_SERVICE_COUNT: 1,

	/** Timeout to logout user automatically when their are required to do login again (in ms) */
	AUTO_LOGOUT_TIMEOUT: 10000,

	/** Session manager constants (in ms) */
	SESSION_TIMEOUT: 1200000, // 20 minutes - TUO inactivity timeout is 30 mins, but adding buffer
	// SESSION_TIMEOUT: 120000, // testing value
	SESSION_CHECK_INTERVAL: 30000, // 30 seconds
	SERVICE_INACTIVITY_TIMEOUT: 1200000, // 20 minutes - TUO inactivity timeout is 30 mins, but adding buffer
	// SERVICE_INACTIVITY_TIMEOUT : 120000, // testing value

	IS_DEV: isDev(),
	PORTAL_URL: getConfigValue(process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_REDIRECTURI),
	DQP_HOME_PAGE: '/meter-inspections',
	SHOW_DEV_PAGES: isDev(),
};

function getConfigValue(value: string | undefined) {
	return value ? value : '';
}

/**
 * Checks if the environment is in development mode.
 * As process.env.NODE_ENV == 'development' doesn't work on dev build; remove on building for > dev
 */
function isDev() {
	const devMainUrls = ['http://localhost', 'https://dev.ehi.rdmw.qld.gov.au', 'https://dev.wateriq.water.qld.gov.au'];
	const configMainUrl = getConfigValue(process.env.NEXT_PUBLIC_WIQ_MSAL_CONFIG_REDIRECTURI);
	return devMainUrls.some(url => configMainUrl.includes(url));
}
